<template>
  <div id="app">
  </div>
</template>

<script type="text/ecmascript-6">
  /*eslint-disable*/
  import Hello from 'components/Hello'
  window.onload = function(){
    debugger
    var href = window.location.href
    if (href.indexOf('localhost') >= 0) {
      window.location.href = '/home.html'
    } else {
      window.location.href = '/home/home.html'
    }

  }
  export default {
    name: 'app',
    components: {
      Hello
    }
  }



</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// App.vue?f2caa6f6